document.addEventListener('alpine:init', () => {
  Alpine.data('VariantSKU', () => ({
    init() {
      this.InitWatchers();
    },
    InitWatchers() {
      let am = this;
      document.addEventListener('variant:change', (e) => {
        am.$el.querySelector('#variant-sku').value = e.detail.variant.barcode;
      });
    }
  }));
});